@if (isInvalidConnection) {
  <p style="text-align: center">Invalid connection: {{ connection }}</p>
}
